// extracted by mini-css-extract-plugin
module.exports = {"detailModal":"WaitListModal_detailModal___Bd0M","button":"WaitListModal_button__pj3WH"};